export default class TipoOcorrencia {

  constructor(
    IdTipoOcorrencia = null,
    Descricao = '',
    Status = 'A'
  ) {
    this.IdTipoOcorrencia = IdTipoOcorrencia;
    this.Descricao = Descricao;
    this.Status = Status;
  }
  
}